// UserWay setProperties payload uses opaque keys `userway-sN`. Mapping captured
// by toggling each control in the widget and observing the postMessage payload.
export enum UserwayFeature {
  Cursor = 'userway-s2',           // Enhanced cursor — DOM
  Contrast = 'userway-s3',         // Cycles 0→1→2→3 (invert / dark / light) — CSS filter
  BiggerText = 'userway-s4',       // DOM
  HighlightLinks = 'userway-s6',   // DOM
  Dyslexia = 'userway-s7',         // Paired with DyslexiaFont — DOM
  UnknownS10 = 'userway-s10',      // Not exposed in current widget config
  Tooltips = 'userway-s12',        // DOM
  PauseAnimations = 'userway-s13', // DOM
  TextSpacing = 'userway-s14',     // DOM
  DyslexiaFont = 'userway-s15',    // UDF font — DOM
  UnknownS16 = 'userway-s16',      // Not exposed in current widget config
  LineHeight = 'userway-s17',      // DOM
  TextAlign = 'userway-s19',       // DOM
  Saturation = 'userway-s23',      // CSS filter
  HideImages = 'userway-s25',      // DOM
}



// WEBPACK FOOTER //
// ./ts/app/shared/userway-feature.ts